import { useCallback, useEffect, useState } from 'react';
import { api } from './api';

/** Fetch `path` (null = skip). Re-runs when `path` changes; `reload()` forces. */
export function useApi(path, options = {}) {
  const { pollInterval = 0, autoRefreshOnFocus = true } = options;
  const [state, setState] = useState({ loading: !!path, data: null, error: null });

  const load = useCallback((isBackground = false) => {
    if (!path) return;
    if (!isBackground) {
      setState((s) => ({ ...s, loading: true, error: null }));
    }
    api
      .get(path)
      .then((data) => setState({ loading: false, data, error: null }))
      .catch((e) => setState({ loading: false, data: null, error: e.message }));
  }, [path]);

  useEffect(() => {
    load(false);

    if (autoRefreshOnFocus) {
      const handleFocus = () => load(true);
      window.addEventListener('focus', handleFocus);
      return () => window.removeEventListener('focus', handleFocus);
    }
  }, [load, autoRefreshOnFocus]);

  useEffect(() => {
    const handleSync = () => load(false);
    window.addEventListener('syncSheet', handleSync);
    return () => window.removeEventListener('syncSheet', handleSync);
  }, [load]);

  useEffect(() => {
    if (!pollInterval || pollInterval <= 0) return;
    const timer = setInterval(() => load(true), pollInterval);
    return () => clearInterval(timer);
  }, [load, pollInterval]);

  return { ...state, reload: () => load(false) };
}
